module.exports = __webpack_public_path__ + "996c0fa1372ccb41127420cd96f9a804.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1083
// module chunks = 0